import { WidgetWrapper } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';
import { formatMoney } from '~/shared/formatMoney.ts';

interface Props {
  readonly specificSearchers: number;
  readonly demandInMrRegion: number;
  readonly vicinitySearchers: number;
  readonly lowDemandPercent: number;
  readonly lowDemandPrice: number;
  readonly highDemandPercent: number;
  readonly highDemandPrice: number;
}

export function PartnerMarketDemandWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <WidgetWrapper title={t('partner_market_demand_title')}>
      <div className="grid gap-6">
        <div className="grid sm:grid-cols-3 gap-4">
          <div className="p-4 rounded-xl border-2 border-primary-100">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Gezielte Suchanfragen
            </p>
            <p className="text-xl font-bold">{props.specificSearchers}</p>
            <p className="text-sm">Personen suchen aktiv Immobilien wie Ihre</p>
          </div>
          <div className="p-4 rounded-xl border-2 border-primary-100">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Regionale Nachfrage
            </p>
            <p className="text-xl font-bold">{props.demandInMrRegion}</p>
            <p className="text-sm">Interessenten in Ihrer Region</p>
          </div>
          <div className="p-4 rounded-xl border-2 border-primary-100">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Nachfrage im Umkreis
            </p>
            <p className="text-xl font-bold">{props.vicinitySearchers}</p>
            <p className="text-sm">
              potenzielle Käufer in der näheren Umgebung
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <div className="p-4 rounded-xl border-2 border-gray-100 dark:border-gray-700">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {formatPercent(props.highDemandPercent)} der Suchenden
            </p>
            <p className="text-xl font-bold">
              {formatMoney(props.highDemandPrice)}
            </p>
            <p className="text-sm">wären bereit, diesen Preis zu zahlen</p>
          </div>
          <div className="p-4 rounded-xl border-2 border-gray-100 dark:border-gray-700">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {formatPercent(props.lowDemandPercent)} der Suchenden
            </p>
            <p className="text-xl font-bold">
              {formatMoney(props.lowDemandPrice)}
            </p>
            <p className="text-sm">würden sogar noch mehr zahlen</p>
          </div>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
          Der Markt ist aktiv, eine gute Ausgangslage für Ihren Verkauf.
        </p>
      </div>
    </WidgetWrapper>
  );
}

function formatPercent(value: unknown) {
  if (typeof value !== 'number') {
    return '';
  }

  let newValue = value || 0;

  if (newValue <= 1) {
    newValue *= 100;
  }

  return `${Math.round(newValue)}%`;
}
